import {configureStore} from '@reduxjs/toolkit'

import studyPeriodReducer from './app/data/StudyPeriod/studyPeriodSlice'

export const store = configureStore({
  reducer: {
    studyPeriod: studyPeriodReducer,
  },
})
